<template>
  <div class="page-footer">
    <footer class="footer border-0 pt-0">
      <div class="container">
        <div class="row pb-4">
          <div class="col-md-12">
            <div class="accordion">

              <div role="tablist">
                <b-card no-body>
                  <b-card-header header-tag="div" class="p-0" role="tab">
                    <b-button block v-b-toggle="'accordion-footer-12'" class="card-header__btn text-left">
                      <b-icon icon="chevron-right" class="mr-2"></b-icon>{{ appSetting.jc_client_text }}
                    </b-button>
                  </b-card-header>
                  <b-collapse id="accordion-footer-12" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text v-html="appSetting.jc_client_info_text"></b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>

              <div role="tablist">
                <b-card no-body>
                  <b-card-header header-tag="div" class="p-0" role="tab">
                    <b-button block v-b-toggle="'accordion-footer-8'" class="card-header__btn text-left">
                      <b-icon icon="chevron-right" class="mr-2"></b-icon>{{ translation[3627] }}
                    </b-button>
                  </b-card-header>
                  <b-collapse id="accordion-footer-8" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text>
                        <div v-if="footerImprint" v-html="footerImprint"></div>
                        <div v-else class="row">
                          <div class="col-12 col-md-4 col-lg-2">
                            <div v-html="translation[10540]"></div>
                          </div>
                          <div class="col-12 col-md-4 col-lg-2">
                            <div v-html="translation[10541]"></div>
                          </div>
                          <div class="col-12 col-md-4 col-lg-2">
                            <div v-html="translation[10542]"></div>
                          </div>
                          <div class="col-12 col-md-4 col-lg-2">
                            <div v-html="translation[10543]"></div>
                          </div>
                          <div class="col-12 col-md-4 col-lg-3">
                            <div v-html="translation[11839]"></div>
                          </div>
                        </div>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>

            </div>
          </div>
        </div>

        <div class="copyright py-3">
          <p>
            {{ translation[10544] }}
            <a
              href="https://www.jobnet.ag"
              target="_blank"
              rel="noopener"
              class="footer__link"
              title="zur Website der Jobnet.AG"
            >Jobnet.AG</a>
            &copy; {{ new Date().getFullYear() }} |
            {{ translation[16015] }} |
            <button @click="showCookieSettings" class="footer__link footer__link--button button_base">
              {{ translation[10545] }}
            </button>
          </p>
        </div>
      </div>
    </footer>

    <b-modal
      v-model="privacyModal"
      hide-header
      ok-only
      size="xl"
      centered
      scrollable
    >
      <div v-html="privacyText"></div>
    </b-modal>
  </div>
</template>

<script lang="ts">
import { AppModule } from '@/store/modules/app';
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PrivacyPolicyMixin from '@/mixins/PrivacyPolicyMixin';

@Component
export default class FooterComponentBbw extends mixins(PrivacyPolicyMixin) {
  get translation() {
    return AppModule.translation;
  }

  get appSetting() {
    return AppModule.setting || {};
  }

  get footerImprint() {
    return this.appSetting.jc_impressum;
  }
}
</script>

<style lang="scss">
[theme="default"] {
  .page-footer .footer {
    font-size: 1.05rem;
    padding-top: 1.5rem;
    line-height: 1.3;
    background-color: #fff;
    font-weight: 300;

    .accordion {
      .card {
        border: none;
        border-top: 1px solid rgba(0, 0, 0, .125);
        border-radius: 0;
        background-color: transparent;
      }
      .card-body {
        a {
          color: var(--portal-primary);
        }

        h1 {
          font-size: 1.7rem;
        }

        h2 {
          font-size: 1.6rem;
        }

        h3 {
          font-size: 1.55rem;
        }
      }
      .card-header {
        background-color: transparent;
        outline: none;
        border-bottom: 0;
        svg {
          transition: transform 0.2s ease;
          color: var(--portal-primary);
        }
        button[aria-expanded="true"] {
          svg {
            transform: rotate(90deg);
          }
        }
        &__btn {
          border: none;
          background-color: transparent;
          font-weight: 600;
          padding: .5rem 0.2rem;
          border-radius: 0;
          text-align: start;
          color: #212529;
          &:focus, &:active, &:hover, &:visited {
            background-color: transparent;
            box-shadow: none !important;
            color: #212529;
          }
        }
      }
      div[role="tablist"]:last-child {
        .card-header {
          border-bottom: 1px solid rgba(0, 0, 0, .125);
        }
      }
    }

    .footer__link {
      color: var(--portal-primary);
      text-decoration: none;
      &:hover {
        color: var(--portal-primary);
        text-decoration: none;
      }
      &--button {
        font-weight: 300;
      }
    }

    .copyright {
      font-size: 0.95rem;
    }
  }

  .button_base {
    background: none;
    border: none;
    padding: 0;
  }
}
</style>
